import { Container } from "react-bootstrap";

const ZohoSupportStudent= () => {

    return (
        <Container className="profile-container d-flex flex-column justify-content-center">
           <div className="w-full my-8">
                <iframe
                    aria-label="Contact for support"
                    frameBorder="0"
                    allow="camera;"
                    style={{ height: "1000px", width: "99%", border: "none" }}
                    src="https://forms.zohopublic.in/edumocks1/form/Contactforsupport/formperma/XzWC15AWvd5O2XrdwiMCWF7nq285a3kj0rHsxaoBS7c?zf_enablecamera=true"
                    title="Contact for Support Form"
                ></iframe>
            </div>
            <div className="support-guidelines mt-4">
                <h4>Support Form Guidelines</h4>
                <ul>
                    <li><strong>Response Time:</strong> Our support team will respond within 6 to 8 hours. Please be patient while we process your request.</li>
                    <li><strong>Avoid Duplicate Submissions:</strong> Submitting the form multiple times may cause delays and could mark your email as spam.</li>
                    <li><strong>Check Your Inbox & Spam Folder:</strong> If you do not receive a response within 8 hours, please check your spam/junk folder before reaching out again.</li>
                    <li><strong>Provide Accurate Details:</strong> Ensure your email ID and issue description are correct to avoid delays in support resolution.</li>
                    <li><strong>Urgent Queries:</strong> For urgent issues, contact us directly at <a href="mailto:help@edumocks.com">help@edumocks.com</a>.</li>
                </ul>
            </div>
        </Container>
    )
}

export default ZohoSupportStudent;
